"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InvoiceTile = _interopRequireDefault(require("./components/InvoiceTile"));
var _MessageCard = _interopRequireDefault(require("../../../components/Cards/MessageCard"));
var _MonthTile = _interopRequireDefault(require("../../../components/MonthTile"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Index = /*#__PURE__*/function (_PureComponent) {
  function Index() {
    (0, _classCallCheck2["default"])(this, Index);
    return _callSuper(this, Index, arguments);
  }
  (0, _inherits2["default"])(Index, _PureComponent);
  return (0, _createClass2["default"])(Index, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        history = _this$props.history,
        hideBalance = _this$props.hideBalance;
      var styles = {
        invoiceHistoryContainer: {
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row'
        }
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.invoiceHistoryContainer
      }, !history || history.length === 0 ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.invoices.noBillingHistory),
        subtitle: _i18n["default"].t(_tokens["default"].labels.invoices.nextChargePhrase)
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_InvoiceTile["default"], {
        isCurrentAllocation: true,
        status: "Pending",
        isFirstInvoice: false,
        onClick: function onClick() {
          return _this.props.getCurrentInvoice();
        }
      }), this.props.history.map(function (invoice, i) {
        return !hideBalance ? /*#__PURE__*/_react["default"].createElement(_InvoiceTile["default"], {
          testid: i === 0 ? 'invoice-history-tile' : undefined,
          key: invoice.dateAdded,
          date: invoice.dateAdded,
          total: invoice.grandTotal,
          status: invoice.status,
          isFirstInvoice: i === history.length - 1,
          onClick: function onClick() {
            return _this.props.selectInvoice(invoice);
          }
        }) : /*#__PURE__*/_react["default"].createElement(_MonthTile["default"], {
          testid: i === 0 ? 'invoice-history-tile' : undefined,
          key: invoice.dateAdded,
          date: invoice.dateAdded,
          isFirstInvoice: i === history.length - 1,
          onClick: function onClick() {
            return _this.props.selectInvoice(invoice);
          },
          status: invoice.status
        });
      })), /*#__PURE__*/_react["default"].createElement("span", {
        id: this.props.testid
      }));
    }
  }]);
}(_react.PureComponent);
Index.propTypes = {
  history: _propTypes["default"].array,
  hideBalance: _propTypes["default"].bool
};
var _default = exports["default"] = Index;